import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageItemProps = ComponentProps<"div">

function ManageItem(props: ManageItemProps) {
  const { className, ...divProps } = props
  return <div className={cn("manage-item", className)} {...divProps} />
}

export default ManageItem
